import {LeaderboardStickyRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {UIDLeaderboardTableRowViewRanked} from './UIDLeaderboardTableRowViewRanked'
import {UIDLeaderboardTableRowViewUnranked} from './UIDLeaderboardTableRowViewUnranked'
import {UIWLeaderboardStickyRowController} from './UIWLeaderboardStickyRowController'

export class UIDLeaderboardStickyRowController extends UIWLeaderboardStickyRowController {
    private _isRanked: boolean

    createStickyTableRowViewUnranked(rowData: LeaderboardStickyRowData) {
        const stickyRowIndex = 0
        this.stickyTableRowView = new UIDLeaderboardTableRowViewUnranked(this.stickyRowDiv, rowData, stickyRowIndex, (leaderboardUrl: string) => undefined)
    }

    createStickyTableRowViewRanked(rowData: LeaderboardStickyRowData) {
        const stickyRowIndex = 0
        this.stickyTableRowView = new UIDLeaderboardTableRowViewRanked(this.stickyRowDiv, rowData, stickyRowIndex, (leaderboardUrl: string) => undefined)
    }

    updateStickyRowData(rowData: LeaderboardStickyRowData, gridHeightPx: number) {
        super.updateStickyRowData(rowData, gridHeightPx)
        this._isRanked = rowData.unrankedOverrideMessage == undefined
    }

    get isRanked(): boolean {
        return this._isRanked
    }
}
